import type {
  AgentStateBookingPanel,
  AgentBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/agentsBookingPanel';

export const get = (state: AgentStateBookingPanel, id: string): AgentBookingPanel => state.byId[id];
export const getAll = (state: AgentStateBookingPanel): Record<string, AgentBookingPanel> =>
  state.byId;
